import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { FmbFaqItem } from '@/consts/frauMeetsBoerse';
import { fmbInternalPath } from '@/components/frauMeetsBoerse/FmbLayout';

interface FmbFaqProps {
  items: FmbFaqItem[];
}

/**
 * FAQ-Akkordeon: erstes Item initial offen, maximal eines gleichzeitig offen.
 */
export default function FmbFaq({ items }: FmbFaqProps) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="flex flex-col border-t border-[var(--fmb-ink)]">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const hasBullets = item.bullets !== undefined && item.bullets.length > 0;

        return (
          <div key={item.question} className="border-b border-[var(--fmb-border-warm)]">
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? -1 : index)}
              className="flex w-full cursor-pointer items-center justify-between gap-6 px-1 py-6 text-left"
            >
              <span className="text-[19px] leading-[1.4] font-bold">{item.question}</span>
              <span className="shrink-0 [font-family:var(--fmb-font-serif)] text-[28px] text-[var(--fmb-accent)]">
                {isOpen ? '–' : '+'}
              </span>
            </button>
            {isOpen && (
              <div className="flex flex-col gap-3 px-1 pb-7">
                <p className="m-0 max-w-[60ch] text-[16px] leading-[1.7] text-pretty text-[var(--fmb-muted)]">
                  {item.answer}
                  {item.answerLink !== undefined && (
                    <>
                      <Link
                        to={fmbInternalPath(item.answerLink.href)}
                        className="text-[var(--fmb-accent)] underline decoration-[var(--fmb-accent)]/40 underline-offset-2 transition-colors hover:decoration-[var(--fmb-accent)]"
                      >
                        {item.answerLink.label}
                      </Link>
                      {item.answerLink.textAfter ?? ''}
                    </>
                  )}
                </p>
                {hasBullets && (
                  <ul className="m-0 flex max-w-[58ch] list-disc flex-col gap-2 pl-[22px] text-[16px] leading-[1.6] text-[var(--fmb-muted)]">
                    {item.bullets?.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
